import { AxiosError } from 'axios';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../components/Notification';
import SingleSelect from '../../../../../../components/SingleSelect';
import HttpStatus from '../../../../../../enums/httpStatus';
import { visitMotiveAPI } from '../../../../../../services/requests';
import { VisitMotive } from '../../../../../../types';
import {
  getOptionByValue,
  getOptionsMotivesSchedule
} from '../../../../../../utils/getSelectOptions';

type Props = {
  closeModal: () => void;
  reqCallback: () => void;
  selectedItem: VisitMotive;
};

type StatusOption = {
  label: string;
  value: 's' | 'n';
};

const ModalEdit = ({ closeModal, reqCallback, selectedItem }: Props) => {
  const { t } = useTranslation();

  const [waitingRequest, setWaitingRequest] = useState(false);

  const statusOptions = useMemo<StatusOption[]>(
    () => [
      { value: 's', label: t('active') },
      { value: 'n', label: t('inactive') },
    ],
    [t],
  );

  const [status, setStatus] = useState<StatusOption>(
    statusOptions.find(
      (option) => option.value === selectedItem.ATIVO.toLowerCase()
    ) ?? statusOptions[0],
  );

  const motiveType = getOptionByValue(selectedItem.FlagMotivo, getOptionsMotivesSchedule());

  const reqEdit = async () => {
    setWaitingRequest(true);

    const source = visitMotiveAPI.axios.CancelToken.source();

    try {
      visitMotiveAPI.query = '';

      const res = await visitMotiveAPI.update(
        {
          ATIVO: status.value,
        },
        selectedItem.CodigoMotivo,
      );

      if (res.status === HttpStatus.OK) {
        frontendNotification({
          message: t('successfullyUpdated'),
          type: 'success',
        });

        reqCallback();
        closeModal();
      } else {
        throw res;
      }
    } catch (err) {
      if (!visitMotiveAPI.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setWaitingRequest(false);
    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={`${t('edit')} ${t('motiveSchedule')}`}
      showModal
      closeModal={closeModal}
      action={() => reqEdit()}
      actionNameBtn={t('save')}
      isLoading={waitingRequest}
    >
      <div style={{ padding: '1rem' }}>
        <p>
          <b>{t('id')}:</b> {selectedItem.CodigoMotivo}
        </p>
        <p>
          <b>{t('motiveFlag')}:</b> {motiveType.label}
        </p>
        <p>
          <b>{t('description')}:</b> {selectedItem.Descricao}
        </p>

        <div style={{ marginTop: '1.5rem' }}>
          <p style={{ marginBottom: '0.5rem' }}>{t('active')}</p>
          <SingleSelect
            value={status}
            options={statusOptions}
            onChange={setStatus as any}
            disabled={waitingRequest}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalEdit;
